import React, { useContext } from 'react'
import { LinguisticLabContext } from './LinguisticLabContext'
import { Word } from 'pages/Words'

const WordCell = (props) => {
    const { value } = props
    const { selectedWordDef } = useContext(LinguisticLabContext)

    const errorTypes = {
        error: {
            error: true
        },
        //count צריך לבדוק למה רק ההשמטות חוזרות עם המילה 
        omission_and_error_count: {
            removed: true,
            error: true
        },
        self_correction_and_minor_error: {
            customStatus: true,
            error: true,
            minorError: true
        },
        //count צריך לבדוק למה רק ההשמטות חוזרות עם המילה 
        omission_and_minor_error_count: {
            minorError: true,
            removed: true
        },
        minor_error: {
            minorError: true
        },
        self_correction: {
            customStatus: true,
            error: true
        },
        repetition: {
            customStatus: true,
        }
    }

    console.log("valueee", value)

    return (
        <Word
            tooltipPlacement={"right"}
            small
            {...errorTypes[value]}
            {...selectedWordDef}
        />
    )
}

export default WordCell